import { IconWrapper } from '../runtime';
export default IconWrapper('mistake-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + 'c48a4e78' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
      "fill": "#D63C3C"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.76666 5.96862C4.43472 5.63668 4.43471 5.09849 4.76666 4.76654C5.0986 4.43459 5.63679 4.43459 5.96874 4.76653L7.99998 6.79775L10.0312 4.76653C10.3632 4.43459 10.9014 4.43459 11.2333 4.76654C11.5652 5.09849 11.5652 5.63668 11.2333 5.96862L9.20207 7.99983L11.2332 10.0309C11.5651 10.3629 11.5651 10.9011 11.2332 11.233C10.9013 11.565 10.3631 11.565 10.0311 11.233L7.99998 9.2019L5.96884 11.233C5.63689 11.565 5.0987 11.565 4.76676 11.233C4.43481 10.9011 4.43482 10.3629 4.76677 10.0309L6.79789 7.99983L4.76666 5.96862Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + 'c48a4e78'
    }
  }, [h("rect", {
    "attrs": {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
});